import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const deleteSurveyStatusSelector = (state: State) =>
  state.deleteSurvey.status;
export const deleteSurveyIdSelector = (state: State) =>
  state.deleteSurvey.entities;
export const deleteSurveyLoadedSelector = isLoaded(deleteSurveyStatusSelector);
export const shouldLoadedDuplicateSurveysSelector = shouldLoad(
  deleteSurveyStatusSelector,
);
export const deleteSurveyRejectedSelector = isRejected(
  deleteSurveyStatusSelector,
);
export const deleteSurveyPendingSelector = isPending(
  deleteSurveyStatusSelector,
);
